import { useState, useEffect } from "react";
import axios from "axios";
import ProgressBar from "./ProgressBar";

const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL 
const EngagementLevel = () => {
  const [engagementData, setEngagementData] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/current-engagement`)
      .then((response) => {
        const res = response.data;
        if (res.success && Array.isArray(res.engagement)) {
          setEngagementData(res.engagement);
        }
      })
      .catch((error) => console.error("Error fetching engagement:", error));
  }, []);

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm w-full border border-gray-100 h-full">
      <h2 className="text-2xl font-bold mb-1 pb-12">Engagement Level</h2>

      {engagementData.length > 0 ? (
        <div className="space-y-4">
          {engagementData.map((item) => (
            <div key={item.name}>
              <div className="flex justify-between text-sm mb-1">
                <span>{item.name}</span>
                <span className="text-red-500 font-semibold">
                  {item.count.toLocaleString()} ({item.percent}%)
                </span>
              </div>
              <ProgressBar value={item.percent} />
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500">No engagement data yet.</p>
      )}
    </div>
  );
}

export default EngagementLevel;
